import React from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";

const Table = ({ data, headerData, bottomLine = true , handleOnSelectRow = ()=>{} }) => {
  return (
    <table className="w-full text-center">
      <TableHeader data={headerData}  />
      {data && <TableBody data={data} bottomLine={bottomLine} handleOnSelectRow={handleOnSelectRow} />}
    </table>
  );
};

export default Table;
